module.exports = __webpack_public_path__ + "static/media/expert-categoriel.63af777f.glb";